import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FormattedMessage } from 'react-intl';

import { currentStage } from '../../api/api';

import logoFacebook from '../../assets/images/logo_facebook.svg';
import logoGoogle from '../../assets/images/logo_google.png';
import logoLine from '../../assets/images/logo_line.png';
import logoTaboola from '../../assets/images/logo_taboola.svg';

import { BoxFlexCenterCenter } from '../customComponent/box';

import * as adAccountConstants from './constants';
import * as basicConstants from '../../constants/basic';
import * as urlConstants from '../../constants/url';

import { LinkCustom } from '../CustomComp';

import theme from '../../theme';

const ChooseMedia = (props) => {
  const { handleSubmit, googleAccountData, handleLoginMedia } = props;
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const handleGetGoogleAccount = () => {
    console.log('LinkGoogle_googleAccountData', googleAccountData)

    handleSubmit({
      media: basicConstants.GOOGLE,
      query: googleAccountData
    });
  }

  const handleGetLineAccount = () => {
    console.log('Linkline_googleAccountData', googleAccountData)

    handleSubmit({
      media: basicConstants.LINE,
      query: googleAccountData
    });
  }

  const ButtonContent = [
    {
      media: 'Facebook',
      buttonName: '新增 Facebook 廣告帳號',
      image: logoFacebook,
      method: 'FacebookAdAuth'
    },
    {
      media: 'Google',
      buttonName: '新增 Google 廣告帳號',
      image: logoGoogle,
      method: 'GoogleAdAuth'
    },
    {
      media: 'LINE',
      buttonName: '新增 LINE 廣告帳號',
      image: logoLine,
      method: 'GoogleAdAuth'
    },
    {
      media: 'Taboola',
      buttonName: '新增 Taboola 廣告帳號',
      image: logoTaboola,
      method: 'GoogleAdAuth'
    }
  ]

  return (
    <>
      <Typography variant="h3" align="center"><FormattedMessage id="account.modal.selectMedia" /></Typography>

      <BoxFlexCenterCenter
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          minWidth: '600px',
          margin: '40px 0 20px 0',
          gap: '20px'
        }}>

        <Box sx={{ width: 'calc(50% - 10px)' }}>
          <Button
            variant="auth-outlined"
            onClick={() => handleLoginMedia('Facebook')}
            sx={{ width: '100%' }}
          >
            <img src={logoFacebook} alt="Facebook" style={{ width: '24px' }} />
            {isDesktop && <FormattedMessage id="account.modal.addAccount" values={{ media: 'Facebook' }} />}
          </Button>
        </Box>

        <Box sx={{ width: 'calc(50% - 10px)' }}>
          <Button
            variant="auth-outlined"
            onClick={() => handleLoginMedia('Google')}
            sx={{ width: '100%' }}
          >
            <img src={logoGoogle} alt="Google" style={{ width: '24px' }} />
            {isDesktop && <FormattedMessage id="account.modal.addAccount" values={{ media: 'Google' }} />}
          </Button>
        </Box>
        {!(currentStage.includes('ext')) &&
          <>
            <Box sx={{ width: 'calc(50% - 10px)' }}>
              <Button
                variant="auth-outlined"
                color="grey"
                onClick={() => handleLoginMedia('Line')}
                sx={{ width: '100%' }}
              >
                <img src={logoLine} alt="LINE" style={{ width: '20px' }} />
                {isDesktop && <FormattedMessage id="account.modal.addAccount" values={{ media: 'LINE' }} />}
              </Button>
            </Box>

            <Box sx={{ width: 'calc(50% - 10px)' }}>
              <Button
                variant="auth-outlined"
                color="grey"
                onClick={() => handleLoginMedia('Taboola')}
                sx={{ width: '100%' }}
              >
                <img src={logoTaboola} alt="Taboola" style={{ width: '20px' }} />
                {isDesktop && <FormattedMessage id="account.modal.addAccount" values={{ media: 'Taboola' }} />}
              </Button>
            </Box>
          </>
        }
      </BoxFlexCenterCenter>

      <Typography variant='body_sm'><FormattedMessage id="account.modal.agreeAllowAccount" /></Typography>

      <Box sx={{ mt: '32px', display: 'flex', justifyContent: 'flex-end' }}>
        <LinkCustom to={urlConstants.PAGE_AD_ACCOUNTS}>
          <Button
            color="grey"
            sx={{
              marginRight: 'auto',
            }}
          >
            <FormattedMessage id="common.button.cancel" />
          </Button>
        </LinkCustom>
      </Box>

    </>
  )
}

export default ChooseMedia;